import { TwinInsightCategory } from 'api/model'
import { atom } from 'recoil'

const insightCategoriesAtom = atom<TwinInsightCategory[]>({
  key: 'insightCategories',
  default: [],
})

const insightsCategoriesLoadingAtom = atom<boolean>({
  key: 'insightCategoriesLoading',
  default: false,
})

export { insightCategoriesAtom, insightsCategoriesLoadingAtom }
